import React, { useRef, useState } from "react";
// 移除了 useMap，因为缩放逻辑将由父组件提供
// import { useMap } from '@vis.gl/react-google-maps'; // 不再需要直接操作 map 实例
import MapCurrentLocation from "@/resource/images/png/lightning/Positioning.svg";
import { Tooltip } from "antd";
import { IGetCurrentReqModel } from "@/util/http/Quantis/requestType";
import { updateCommonErrorMessage, updateCommonWarnMessage } from "@/redux/actions/lightningAction";
import { useDispatch, useSelector } from "react-redux";
import { LightningSwitchMapIcon } from "@/resource/IconComponents";
interface IZoomControlsProps {
  onZoomIn: () => void; // 放大回调
  onZoomOut: () => void; // 缩小回调
  toggleMapType?: ()=>void
  handleMapCenterForCurrent?: (lat: number, lng: number) => void; // 用于设置地图中心点的回调函数
  // 可以添加 maxZoom 和 minZoom 来禁用按钮
  currentZoom?: number;
  minZoom?: number;
  maxZoom?: number;
}

const ZoomControls: React.FC<IZoomControlsProps> = ({
    onZoomIn,
    onZoomOut,
    toggleMapType,
    handleMapCenterForCurrent,
    currentZoom,
    minZoom,
    maxZoom
}) => {

    const canZoomIn = currentZoom === undefined || maxZoom === undefined || currentZoom < maxZoom;
    const canZoomOut = currentZoom === undefined || minZoom === undefined || currentZoom > minZoom;


    const dispatch = useDispatch();
    const [selectedCoordinate, setSelectedCoordinate] = useState<IGetCurrentReqModel | undefined>({
        lat: 10.99835602,
        lng: 77.01502627
    });
    const [isCurrentLocationTooltipVisible, setIsCurrentLocationTooltipVisible] = useState(false);
    const [isZoomInTooltipVisible, setIsZoomInTooltipVisible] = useState(false);
    const [isZoomOutTooltipVisible, setIsZoomOutTooltipVisible] = useState(false);
    const [isSwitchMapTooltipVisible, setIsSwitchMapTooltipVisible] = useState(false);
    const isMobileDevice = () => {
        return /Mobi|Android/i.test(navigator.userAgent);
    };
    const mapRef = useRef<any>(null);
    const handleShowCurrentLocation = () => {
        try {
            navigator.geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    setSelectedCoordinate(pos);
                    if(pos?.lat && pos.lng) {
                        handleMapCenterForCurrent(pos.lat, pos.lng);
                    }

                    if (mapRef && mapRef.current) {
                        mapRef.current.setCenter(pos);
                    }
                },
                (error) => {
                    dispatch(updateCommonWarnMessage("Location not found. Please ensure location services are enabled."));
                }
            );
        } catch (error) {
            dispatch(updateCommonErrorMessage("An unexpected error occurred while fetching your location."));
        }
    };
    return (
        <div className="button-div" style={{
            position: "absolute",
            right: "20px",
            display: "flex",
            flexDirection: "column",
            zIndex: 9999,
            borderRadius: "4px",
            padding: "4px",
            gap:"10px",
        }}>
            {/* <Tooltip title="Current Location" placement="left" visible={isCurrentLocationTooltipVisible}>
                <button className='query-toggle-map-center'
                    onMouseEnter={() => setIsCurrentLocationTooltipVisible(true)}
                    onMouseLeave={() => setIsCurrentLocationTooltipVisible(false)}
                    onTouchStart={() => {
                        if (isMobileDevice()) {
                            setIsCurrentLocationTooltipVisible(true);
                            setTimeout(() => {
                                setIsCurrentLocationTooltipVisible(false);
                            }, 1000); // Hide tooltip after 2 seconds
                        }
                    }}
                    onClick={() => handleShowCurrentLocation()}>
                    <img src={MapCurrentLocation} />
                </button>
            </Tooltip> */}

            <div className="lightning-zoom">
                <Tooltip title="Switch Map" placement="left" visible={isSwitchMapTooltipVisible}>
                    <button
                        onClick={toggleMapType}
                        disabled={!canZoomOut} // 禁用条件
                        // className="lightning-zoom-out"
                        style={{
                            cursor: canZoomOut ? "pointer" : "not-allowed",
                        }}
                        onMouseEnter={() => setIsSwitchMapTooltipVisible(true)}
                        onMouseLeave={() => setIsSwitchMapTooltipVisible(false)}
                    >
                        <LightningSwitchMapIcon color="green" width={30} height={30}/>
                    </button>
                </Tooltip>
            </div>
            <div className="lightning-zoom">
                <Tooltip title="Zoom In" placement="left" visible={isZoomInTooltipVisible}>
                    <button
                        onClick={onZoomIn}
                        disabled={!canZoomIn} // 禁用条件
                        className="lightning-zoom-in"
                        style={{
                            cursor: canZoomIn ? "pointer" : "not-allowed",
                        }}
                        onMouseEnter={() => setIsZoomInTooltipVisible(true)}
                        onMouseLeave={() => setIsZoomInTooltipVisible(false)}
                    >
        +
                    </button>
                </Tooltip>
                <Tooltip title="Zoom Out" placement="left" visible={isZoomOutTooltipVisible}>
                    <button
                        onClick={onZoomOut}
                        disabled={!canZoomOut} // 禁用条件
                        className="lightning-zoom-out"
                        style={{
                            cursor: canZoomOut ? "pointer" : "not-allowed",
                        }}
                        onMouseEnter={() => setIsZoomOutTooltipVisible(true)}
                        onMouseLeave={() => setIsZoomOutTooltipVisible(false)}
                    >
        -
                    </button>
                </Tooltip>

            </div>




        </div>
    );
};

export default React.memo(ZoomControls);